export default __webpack_public_path__ + "static/media/alternative-address.024a4268.svg";